import { data_select, setBuilderId, setDataSelect } from "../results-load/results-state";
export function prepareInitialFilters(data) {
    if (data.id_builder > 0) {
        setBuilderId(Number(data.id_builder));
        return;
    }
    if (localStorage.filters) {
        setDataSelect(JSON.parse(localStorage.filters));
        localStorage.removeItem('filters');
        return;
    }
    applyUrlPrefilters();
    applyDataFilters(data);
}
function applyUrlPrefilters() {
    if (data_select.department_list.length === 0) {
        const department = filterDepartment('', 'prefilter');
        if (Array.isArray(department)) {
            data_select.department_list.push(department[1]);
        }
    }
    if (data_select.cities.length === 0) {
        const city = filterCity('', 'prefilter');
        if (Array.isArray(city)) {
            data_select.cities.push(city[1]);
        }
    }
    if (data_select.price.length === 0) {
        const price = filterPrice('', 'prefilter');
        if (Array.isArray(price)) {
            data_select.price.push(price[1]);
        }
    }
}
function applyDataFilters(data) {
    const listFields = {
        project_collection: 'coleccion',
        field_project_type: 'vis',
        project_category: 'categori',
    };
    Object.keys(data).forEach((element) => {
        var _a;
        const nameField = (_a = listFields[element]) !== null && _a !== void 0 ? _a : element;
        if (!Array.isArray(data_select[nameField]))
            return;
        if (!data_select[nameField].includes(data[element])) {
            data_select[nameField].push(data[element]);
        }
    });
}
export function filterDepartment(filter, section = '') {
    const queryString = window.location.search;
    let department = '';
    if (!filter.includes('department') && queryString.includes('department')) {
        const urlParams = new URLSearchParams(queryString);
        department = urlParams.get('department');
        filter += `&department=${department}`;
        if (section === 'prefilter') {
            data_select['department_list'].push(department);
        }
    }
    return filter;
}
export function filterCity(filter, section = '') {
    const queryString = window.location.search;
    if (!filter.includes('cityId') && queryString.includes('cityId')) {
        const urlParams = new URLSearchParams(queryString);
        const cityId = urlParams.get('cityId');
        filter += `&cityId=${cityId}`;
        if (section == 'prefilter' && cityId) {
            const cityIds = cityId.split(',');
            cityIds.forEach(id => {
                data_select['cities'].push(id);
            });
        }
    }
    return filter;
}
export function filterZone(filter, section = '') {
    const queryString = window.location.search;
    if (!filter.includes('zoneId') && queryString.includes('zoneId')) {
        const urlParams = new URLSearchParams(queryString);
        const zoneId = urlParams.get('zoneId');
        filter += `&zoneId=${zoneId}`;
        if (section == 'prefilter') {
            data_select['zone'].push(zoneId);
        }
    }
    return filter;
}
export function filterPrice(filter, section = '') {
    const queryString = window.location.search;
    if (!filter.includes('price') && queryString.includes('price')) {
        const urlParams = new URLSearchParams(queryString);
        const price = urlParams.get('price');
        filter += `&price=${price}`;
        if (section == 'prefilter') {
            data_select['price'].push(price);
        }
    }
    return filter;
}
